import { ENV } from './utils/env';
export const baseApiEndpoint = ENV.VITE_APP_BASE_URL;

export const baseApiTrucEndpoint = ENV.VITE_APP_API_URL_TRUC;
